export default {
  add_items: 'Adaugă produse',
  remove_items: 'Elimină produse',
  place_order: 'Plasează comanda',
  pay_now: 'Plătește acum · {{amount}}',
  go_to_menu: 'Mergi la meniu',
  secure_checkout: 'Finalizare securizată...',

  modals: {
    account_switch: {
      title: 'Contul cu numărul de telefon {{phoneNumber}} există deja',
      description: 'Te-am conectat la contul existent, păstrând informațiile introduse 😊',
      button: 'Continuă',
    },
  },

  error_messages: {
    payment_unsuccessful: {
      title: 'Plată eșuată',
      description: 'Verifică datele de plată și încearcă din nou.',
    },
    internal_error: {
      title: 'Comandă nereușită 😔',
      description:
        'Din păcate, a apărut o problemă neașteptată cu comanda ta. Echipa noastră tehnică lucrează deja la rezolvare 🛠️.',
    },
    order_blocked: {
      title: 'Comandă blocată',
      description:
        'Am detectat activitate suspectă din contul tău și am blocat comenzile noi până la {{datetime}}. Contactează suportul la {{supportEmail}} pentru detalii.',
      description_no_datetime:
        'Am detectat activitate suspectă din contul tău și am blocat comenzile noi. Contactează suportul la {{supportEmail}} pentru detalii.',
    },
  },

  toasts: {
    input_errors_found: 'Există unele probleme cu informațiile comenzii tale',
    select_payment_method: 'Alege o metodă de plată pentru a plasa comanda.',
  },
};
